<script>
  import { refreshToken, isAuthenticated, userInfo, isLoading } from '@dopry/svelte-oidc'
</script>

<style>
  .agent-info {
    font-size: 12px;
    line-height: 22px;
    margin-bottom: 8px;
    color: #8e949a;
  }
</style>

{#if !$isLoading}
  <div class="container" data-test="login-status">
    {#if $isAuthenticated}
      <p class="agent-info">Agent: {$userInfo.given_name} {$userInfo.family_name}</p>
    {:else}
      You are not currently authenticated.
      <br />
      <a href="http://login.microsoftonline.com/" target="blank">
        Click here to open a new window and login to Hagerty SSO.
      </a>
      <br />
      After Logging into SSO, click the button below Authenticate the widget.
      <br />
      <button data-test="login-refresh" on:click={refreshToken}>
        Re-authenticate Widget
      </button>
    {/if}
  </div>
{/if}
